module.exports = __webpack_public_path__ + "img/bussy.443c51a1.svg";